import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import map from 'lodash/map';
export function isRentalLocatorFormEmpty(props) {
    return !props.countries.length || !props.googleApiKey;
}
export const getCategoryById = (categories, categoryId) => find(categories, {
    categoryId,
});
export const getCountriesCodes = (countries) => map(countries, ({ code }) => code.toLowerCase());
export const getCategoriesDDItems = (categories, selectedCategory) => {
    return map(categories, ({ categoryId, categoryName }) => ({
        value: categoryId,
        label: categoryName,
        checked: selectedCategory
            ? selectedCategory.some((item) => item.categoryId === categoryId)
            : false,
    }));
};
export const sortFiltersItemsAlphabetical = (filters, locale = '') => {
    return filters?.sort((a, b) => a?.label?.localeCompare(b?.label, locale));
};
export const filterRentalPoints = (rentalPoints, selectedCategory) => {
    if (isEmpty(rentalPoints)) {
        return [];
    }
    if (!selectedCategory?.length) {
        return rentalPoints;
    }
    const rentalPointsForCategory = rentalPoints?.filter((rentalPoint) => rentalPoint.categoryIds.some((category) => selectedCategory.some((selectedCategory) => selectedCategory.categoryId === category)));
    return rentalPointsForCategory || [];
};
export const removeDistanceFromRentalPoints = (rentalPoints) => map(rentalPoints, (rentalPoint) => {
    rentalPoint.distance = 0;
    return rentalPoint;
});
export const fromCoordinatesToCoordinatesV2 = (coordinates) => ({
    latitude: coordinates.lat,
    longitude: coordinates.lng,
});
